import React from 'react';

import { useSnackbar } from 'notistack';

import { CopyAll } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

import { CreateSinglePromoClonePayload } from '~/hooks/usePromo';

import { BulkCreatePromosResult } from '~/services/PromoService';

type PromoCopyButtonProps = {
  promoId: string;
  codeName: string;
  parentCodeName: string | null;
  createSinglePromoClone: (payload: CreateSinglePromoClonePayload) => Promise<BulkCreatePromosResult>;
  isLoading: boolean;
};

function PromoCopyButton({
  promoId,
  codeName,
  createSinglePromoClone,
  isLoading,
  parentCodeName,
}: PromoCopyButtonProps) {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyPromo = async () => {
    const promo = await createSinglePromoClone({
      id_promo_code: promoId,
      promo_prefix: parentCodeName ?? codeName,
    });
    if (promo) {
      await navigator.clipboard.writeText(promo.result.promos[0].code_name);
      enqueueSnackbar(`${promo.result.promos[0].code_name}: Promo code created and copied to clipboard!`, {
        variant: 'success',
      });
    }
  };

  return (
    <Button variant="contained" onClick={handleCopyPromo} disabled={isLoading}>
      {isLoading ? (
        'Copying...'
      ) : (
        <Typography>
          Clone this Promo <CopyAll />
        </Typography>
      )}
    </Button>
  );
}

export default PromoCopyButton;
